<form class="modal-body" [formGroup]="form" (ngSubmit)="update()" novalidate>
  <p class="centermodal__title">{{ 'settings.changeOrganizationData' | translate }}</p>

  <div class="centermodal__form" formGroupName="organization">
    <label class="field__holder" [appFormControlWrap]="form.get('organization.name')">
      <input type="text" class="field" formControlName="name" name="company" autocomplete="company" appValidCompanyName #companyInput />
      <span class="field__placeholder">{{ 'profile.businessName' | translate }}</span>
    </label>
    <label class="field__holder mb-0" [appFormControlWrap]="form.get('organization.locale.country')" formGroupName="locale">
      <app-select placeholder="{{ 'profile.country' | translate }}" formControlName="country" [options]="countries" [required]="true"></app-select>
    </label>
    @if (form.get('organization.locale.country').value === 'BR') {
      <label class="field__holder" [appFormControlWrap]="form.get('organization.cnpj')">
        <input type="text" class="field" formControlName="cnpj" name="cnpj" autocomplete="cnpj" mask="00.000.000/0000-00" />
        <span class="field__placeholder">{{ 'profile.cnpj' | translate }}</span>
      </label>
    }
    <label class="field__holder mb-0" [appFormControlWrap]="form.get('organization.locale')" formGroupName="locale">
      <app-select placeholder="{{ 'profile.language' | translate }}" formControlName="language" [disableSearch]="true" [options]="languages"> </app-select>
    </label>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
    <button type="submit" class="btn-L btn-filled" [disabled]="form.invalid || isLoading">{{ 'button.save' | translate }}</button>
  </div>
</form>
